import React from 'react';
import {
  RichTreeView,
  TreeItem,
  TreeItemProps,
  useTreeItemModel,
} from '@mui/x-tree-view';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import ArrowDownIcon from '@material-ui/icons/ArrowDropDown';
import {
  PermissionTreeDescription,
  PermissionTreeLabel,
  PermissionTreeName,
  PermissionTreeRoot,
} from './styles';
import { RolePermissionNode } from './types';

const RolePermissionTreeItem = React.forwardRef<HTMLLIElement, TreeItemProps>(
  function RolePermissionTreeItem(props, ref) {
    const permissionNode = useTreeItemModel<RolePermissionNode>(props.itemId);

    return (
      <TreeItem
        {...props}
        ref={ref}
        label={
          <PermissionTreeLabel>
            <PermissionTreeName>{permissionNode?.label}</PermissionTreeName>
            {permissionNode?.description ? (
              <PermissionTreeDescription>
                {permissionNode.description}
              </PermissionTreeDescription>
            ) : null}
          </PermissionTreeLabel>
        }
      />
    );
  },
);

interface RolePermissionTreeProps {
  items: RolePermissionNode[];
  selectedPermissionIds: string[];
  expandedPermissionIds: string[];
  disabled: boolean;
  onSelectedPermissionIdsChange: (selectedPermissionIds: string[]) => void;
  onExpandedPermissionIdsChange: (expandedPermissionIds: string[]) => void;
}

export function RolePermissionTree({
  items,
  selectedPermissionIds,
  expandedPermissionIds,
  disabled,
  onSelectedPermissionIdsChange,
  onExpandedPermissionIdsChange,
}: RolePermissionTreeProps) {
  return (
    <PermissionTreeRoot>
      <RichTreeView
        key={disabled ? 'read' : 'edit'}
        items={items}
        checkboxSelection
        multiSelect
        selectedItems={selectedPermissionIds}
        expandedItems={expandedPermissionIds}
        isItemDisabled={() => disabled}
        expansionTrigger="content"
        getItemLabel={(item: RolePermissionNode) => item.label}
        onSelectedItemsChange={(_, itemIds) => {
          if (!Array.isArray(itemIds)) return;
          onSelectedPermissionIdsChange(itemIds);
        }}
        onExpandedItemsChange={(_, itemIds) => {
          onExpandedPermissionIdsChange(itemIds);
        }}
        itemChildrenIndentation={0}
        selectionPropagation={{
          descendants: true,
          parents: true,
        }}
        slots={{
          item: RolePermissionTreeItem,
          expandIcon: ArrowRightIcon,
          collapseIcon: ArrowDownIcon,
        }}
      />
    </PermissionTreeRoot>
  );
}
